import { daysBetween } from '@/utils/date'
/**
 * @ Author: Housefolios
 * @ Create Time: 2024-06-18 14:50:05
 * @ Modified by: David Helmick
 * @ Modified time: 2025-10-27 11:20:30
 * @ Modified time: 2025-10-27 11:20:38
 */

import React, { useState } from 'react'

// Centralized lodash imports - much cleaner!
import {
  map,
  find,
  ceil,
  slice,
  pull,
  isString,
  every,
  isNil,
  filter,
  includes,
} from '@/utils/lodash'
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  Dialog,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  List,
  ListItem,
  Menu,
  Table,
  TableCell,
  TableSortLabel,
  Tooltip,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Pagination,
  Box,
} from '@mui/material'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import HousefoliosUser from '@/assets/images/Housefolios_user.png'
import { useMutation } from '@apollo/client/react'
import withSession from '@/housefolios-components/Session/withSession'
import { enqueueSnackbar } from 'notistack'
import { GET_ACTIVE_ORGS } from '@/housefolios-components/ReportsComponents/Reports/queries'
import { UPDATE_USER } from '@/housefolios-components/PersonalSettings/mutations'
import { GET_ME } from '@/housefolios-components/Session/queries'
import { GET_PORTFOLIOS } from '@/housefolios-components/Portfolio/queries'
import useSorting, {
  getSorting,
  stableSort,
} from '@/hooks/useSorting'

// const status = [
//   {
//     name: orgCreator,
//     color: '#4290ff',
//   },
//   {
//     name: pending,
//     color: '#FF8300',
//   },
//   {
//     name: deactivated,
//     color: '#E4000F',
//   },
//   {
//     name: active,
//     color: '#46de64',
//   },
// ]

function AffiliateAdminTableComponent(props) {
  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedMember, setSelectedMember] = useState('')
  const [openDelete, setOpenDelete] = useState(false)
  const [openDisable, setOpenDisable] = useState(false)
  const [confirm, setConfirm] = useState(false)
  const handleOpenMoreActions = (event, _id) => {
    setAnchorEl(event.currentTarget)
    setSelectedMember(_id)
  }
  const handleCloseMoreActions = () => {
    setAnchorEl(null)
    setSelectedMember('')
    setOpenDelete(false)
    setOpenDisable(false)
    setConfirm(false)
  }
  const toggleOpenDelete = () => {
    setOpenDelete(!openDelete)
  }

  const { affiliateAdmins = [] } =
    props.session.me.activeOrg.isAffiliate

  const [updateUser] = useMutation(UPDATE_USER)

  const toggleRemove = (userId) => {
    const user = find(
      affiliateAdmins,
      (admin) => admin._id === userId,
    )
    let affiliateAdmin = [...user.affiliateAdmin]
    pull(
      affiliateAdmin,
      props.session.me.activeOrg.isAffiliate?.memberValue,
    )
    updateUser({
      variables: {
        id: userId,
        userInput: {
          affiliateAdmin,
        },
      },
      refetchQueries: [{ query: GET_ME }],
    })
    setOpenDelete(false)
  }

  const [{ order, orderBy }, { handleRequestSort }] = useSorting({
    defaultOrder: 'asc',
    defaultOrderBy: 'createdAt',
  })

  const [page, setPage] = useState(
    parseInt(localStorage.getItem('team-page')) || 1,
  )
  const handleChange = (event, value) => {
    localStorage.setItem('team-page', value)
    setPage(value)
  }

  const visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  }

  let tableHeaders = [
    { title: 'First Name', name: 'firstname' },
    { title: 'Last Name', name: 'lastname' },
    { title: 'Email', name: 'email' },
    { title: 'Last Login', name: 'lastLogin' },
    // { title: 'Subscription', name: 'subscriptions[0].plan.nickname'},
    // { title: props.isAdmin ? 'Subscription Amount' : 'Commission Amount' , name: 'subscriptions[0].plan.amount'},
    // { title: 'Created Date', name: 'subscriptions[0].created'},
    // { title: 'Trial Start', name: 'subscriptions[0].trial_start'},
    // { title: 'Trial End', name: 'subscriptions[0].trial_end'},
    // { title: 'Affiliate', name: 'referredByDetails.affiliateId'}
  ]

  const searchFilter = (admin) => {
    const { search = '' } = props
    return (
      includes(admin.profile?.firstname, search) ||
      includes(admin.profile?.lastname, search) ||
      includes(admin.email, search)
    )
  }

  const count = ceil(affiliateAdmins?.length / 20)
  return (
    <Card variant="outlined" style={{ width: '100%' }}>
      <Box sx={[{
        display: "flex",
        alignItems: "center",
        py: "0.75rem",
        px: "1.25rem",
        mb: 0,
        backgroundColor: "#fff",
        padding: "0.75rem 1.25rem",
        marginBottom: 0,
        borderBottom: "0 solid rgba(79, 80, 98, 0.3)",
        "&:first-of-type": { borderRadius: "0.65rem 0.65rem 0 0" },
        "html[data-color-mode=\"dark\"] &": { backgroundColor: "#252525 !important", color: "rgba(255, 255, 255, 0.87)", borderColor: "rgba(255, 255, 255, 0.12) !important" },
      }, { pr: '0.5rem' }]}>
        <Box sx={{
          flexGrow: 1,
          minWidth: 0,
          "& > b": { display: "block" },
          "& > small": {
            textTransform: "uppercase",
            display: "block",
            opacity: 0.3,
            fontWeight: "bold",
          },
        }}>
          {/* <small>{props.session.me.activeOrg.name}</small> */}
          <b>Admins</b>
        </Box>
        <div style={{marginLeft:"auto",display:"flex",alignItems:"center",flexShrink:0}}>
          {/* <AddUser teamTable={true} teamCount={data.teamMembers.length} /> */}
        </div>
      </Box>
      <CardContent sx={{ p: 0 }}>
        <TableContainer component={Paper}>
          <Table sx={[{ whiteSpace: 'nowrap', mb: 0 }, {
            width: "100%",
            marginBottom: "1rem",
            fontSize: "1rem",
            "& th, & td": { padding: "0.75rem", borderTop: "1px solid #e4e5f0", verticalAlign: "middle" },
            "& thead th": {
              textTransform: "uppercase",
              background: "#f4f5fd",
              fontSize: "0.875rem",
              verticalAlign: "middle",
              borderBottom: "2px solid #e4e5f0",
            },
            "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.87)" },
          }]}>
            <TableHead>
              <TableRow sx={{ textAlign: 'center' }}>
                {map(
                  filter(tableHeaders, (header) => !header.hide),
                  (column) => (
                    <TableCell
                      key={column.title}
                      align={column.align}
                      sortDirection={
                        orderBy === column.name ? order : false
                      }
                    >
                      {column.name ? (
                        <TableSortLabel
                          active={orderBy === column.name}
                          direction={order}
                          onClick={(event) =>
                            handleRequestSort(event, column.name)
                          }
                        >
                          {column.title}
                          {orderBy === column.name ? (
                            <span style={visuallyHidden}>
                              {order === 'desc'
                                ? 'sorted descending'
                                : 'sorted ascending'}
                            </span>
                          ) : null}
                        </TableSortLabel>
                      ) : (
                        column.title
                      )}
                    </TableCell>
                  ),
                )}
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {map(
                slice(
                  stableSort(
                    filter(affiliateAdmins, searchFilter),
                    getSorting(order, orderBy),
                  ),
                  (page - 1) * 20,
                  page * 20,
                ),
                (admin) => {
                  const { profile = {}, lastLogin } = admin
                  const { firstname, lastname } = profile
                  let login = 'has not logged in'
                  if (lastLogin) {
                    const today = new Date()
                    let days = daysBetween(today, lastLogin)
                    days = Math.abs(days)
                    days = Math.round(days)
                    login = days ? `${days} days ago` : 'today'
                  }
                  return (
                    <TableRow key={admin._id}>
                      <TableCell>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          {/* <div>
                            <div>
                              <div
                                style={{
                                  backgroundImage: `url(${org && org.logo && org.logo.url_small ? org.logo.url_small : HousefoliosUser
                                    })`,
                                }}
                              >
                                <img alt="..." src={org.logo ? org.logo.url : HousefoliosUser} />
                              </div>
                            </div>
                          </div> */}
                          <div>
                            <Box component="a" href="/" onClick={(e) => e.preventDefault()} title="..." sx={[{ fontWeight: 700 }, {
                              color: "#070919",
                              "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.87) !important" },
                            }]}>
                              {firstname}
                            </Box>
                          </div>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          {/* <div>
                            <div>
                              <div
                                style={{
                                  backgroundImage: `url(${org && org.logo && org.logo.url_small ? org.logo.url_small : HousefoliosUser
                                    })`,
                                }}
                              >
                                <img alt="..." src={org.logo ? org.logo.url : HousefoliosUser} />
                              </div>
                            </div>
                          </div> */}
                          <div>
                            <Box component="a" href="/" onClick={(e) => e.preventDefault()} title="..." sx={[{ fontWeight: 700 }, {
                              color: "#070919",
                              "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.87) !important" },
                            }]}>
                              {lastname}
                            </Box>
                          </div>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <div>{admin.email || admin.username}</div>
                      </TableCell>
                      <TableCell>
                        <div>{login}</div>
                      </TableCell>
                      <TableCell>
                        <div>
                          <Tooltip title="More Actions">
                            <IconButton
                              onClick={(event) =>
                                handleOpenMoreActions(
                                  event,
                                  admin._id,
                                )
                              }
                              style={{
                                backgroundColor:
                                  'rgba(54, 140, 255, 0.22)',
                                color: '#90caf9',
                                height: 30,
                                width: 30,
                              }}
                              size="large"
                            >
                              <FontAwesomeIcon icon={['fas', 'ellipsis']} sx={{ fontSize: "1.15rem !important" }} />
                            </IconButton>
                          </Tooltip>
                        </div>
                        <Menu
                          anchorEl={anchorEl}
                          keepMounted
                          open={
                            Boolean(anchorEl) &&
                            admin._id === selectedMember
                          }
                          onClose={handleCloseMoreActions}
                          MenuListProps={{ sx: { p: 0 } }}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                          }}
                        >
                          <div>
                            <List
                              component="div"
                              sx={{
                                "& .MuiListItem-root.MuiListItem-button": { borderRadius: 0 },
                                "& .MuiListItem-root.MuiListItem-button.Mui-selected, & .MuiListItem-root.MuiListItem-button:hover, & .MuiListItemButton-root.Mui-selected, & .MuiListItemButton-root:hover": {
                                  color: "#368cff",
                                  background: "rgba(54, 140, 255, 0.05)",
                                  "&::before": { background: "#368cff" },
                                },
                              }}
                            >
                              <ListItem
                                button
                                key="removeAdmin"
                                onClick={toggleOpenDelete}
                              >
                                <span>Remove Admin Privilege</span>
                              </ListItem>
                            </List>
                          </div>
                        </Menu>
                      </TableCell>
                    </TableRow>
                  )
                },
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ background: "#eeeff8", height: "1px", overflow: "hidden" }} />
        <Box sx={{ background: "#eeeff8", height: "1px", overflow: "hidden" }} />
        <Box
          sx={{
            p: '1rem',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Pagination size="small" count={count} page={page} onChange={handleChange} />
        </Box>
      </CardContent>
      <Dialog
        open={openDelete}
        onClose={toggleOpenDelete}
      >
        <Box sx={{ textAlign: 'center', p: '3rem' }}>
          <Box sx={[{ borderRadius: '50%', m: 0 }, {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            mr: "0.25rem",
            position: "relative",
            fontSize: "1.2rem",
            transition: "all 0.2s ease-in-out",
            "&:last-child": { mr: 0, marginRight: 0 },
            "& .badge": { position: "absolute", right: 0, bottom: 0 },
            "& svg, & .svg-inline--fa": { display: "block" },
            marginRight: "0.25rem",
          }]}>
            <Box sx={[{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              border: 0,
              backgroundColor: "rgb(100%, 95.9215686275%, 96.418938307%) !important",
              height: "130px !important",
              width: "130px !important",
              lineHeight: "130px !important",
              p: 0,
              borderRadius: "50%",
              color: "#f83245",
              m: 0,
            }, {
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              mr: "0.25rem",
              position: "relative",
              fontSize: "1.2rem",
              transition: "all 0.2s ease-in-out",
              "&:last-child": { mr: 0, marginRight: 0 },
              "& .badge": { position: "absolute", right: 0, bottom: 0 },
              "& svg, & .svg-inline--fa": { display: "block" },
              marginRight: "0.25rem",
            }]}>
              <FontAwesomeIcon icon={['fal', 'user-slash']} size="10x" style={{ display: 'flex', alignSelf: 'center' }} sx={{ fontSize: "2.5rem", fontWeight: "300", lineHeight: "1.2" }} />
            </Box>
          </Box>
          <Box component="h4" sx={{ fontWeight: 700, mt: '1.5rem' }}>
            Remove Admin Privileges?
          </Box>
          <Box sx={[{ mb: 0, color: '#a6a6b9' }, { fontSize: "1.15rem !important" }]}>
            <FormControl component="fieldset" sx={{ pr: '1.5rem' }}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={confirm}
                      onChange={() => setConfirm(!confirm)}
                    />
                  }
                  label="Make this user no longer an Admin"
                />
              </FormGroup>
            </FormControl>
          </Box>
          <Box sx={{ pt: '1.5rem' }}>
            <Button variant="text" onClick={toggleOpenDelete}>
              <Box component="span" sx={{
                display: "inline-block",
                "&:not(:first-of-type)": { ml: "0.5rem", marginLeft: "0.5rem" },
                "& + .btn-wrapper--icon": { ml: "0.5rem", marginLeft: "0.5rem" },
              }}>Cancel</Box>
            </Button>
            <Button
              variant="contained"
              style={{
                backgroundColor: '#f83145',
                color: 'white',
              }}
              onClick={(event) => toggleRemove(selectedMember)}
              disabled={!confirm}
            >
              <Box component="span" sx={{
                display: "inline-block",
                "&:not(:first-of-type)": { ml: "0.5rem", marginLeft: "0.5rem" },
                "& + .btn-wrapper--icon": { ml: "0.5rem", marginLeft: "0.5rem" },
              }}>Remove</Box>
            </Button>
          </Box>
        </Box>
      </Dialog>
    </Card>
  )
}

export default withSession(AffiliateAdminTableComponent)
